import React, { Component } from 'react'
import { action } from 'mobx';
import { observer, inject } from 'mobx-react';
import SearchFiltersToolbar from 'components/SearchFiltersToolbar';
import SearchFiltersSearchButton from 'components/SearchFiltersSearchButton';

// Pricebook search (pages/products_services/index.js). The page header holds
// "Add item"; this bar is just the name search, applied on Search or Enter.
@inject('viewStore', 'productServiceStore') @observer
class ProductService extends Component {

  @action
  search() {
    this.props.viewStore.productServiceIndexSearch.page = 1;
    this.props.productServiceStore.loadProductsServices();
  }

  @action
  onSearchTermChange(event) {
    const { viewStore } = this.props;
    viewStore.productServiceIndexSearch = {
      ...viewStore.productServiceIndexSearch,
      term: event.target.value,
    };
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  render() {
    let { term } = this.props.viewStore.productServiceIndexSearch;
    if (term === '*') {
      term = '';
    }
    return (
      <SearchFiltersToolbar searchButton={<SearchFiltersSearchButton onClick={this.search.bind(this)} />}>
        <input
          type="text"
          className="bp3-input search-filters-toolbar__field-wide"
          placeholder="Search by name"
          aria-label="Search the pricebook by name"
          onChange={this.onSearchTermChange.bind(this)}
          defaultValue={term}
          onKeyPress={this.onEnter.bind(this)}
        />
      </SearchFiltersToolbar>
    );
  }
}

export default ProductService;
